import dynamic from "next/dynamic";

export const AreasOfExpertise = dynamic(() => import("./component"));
